import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RegisterRecordsQueryVariables = Types.Exact<{
  input: Types.RegisterRecordsInput;
}>;


export type RegisterRecordsQuery = { readonly __typename?: 'Query', readonly registerRecords?: { readonly __typename?: 'PaginatedRegisterRecord', readonly total?: number | null, readonly limit?: number | null, readonly offset?: number | null, readonly records?: ReadonlyArray<{ readonly __typename?: 'RegisterRecord', readonly _id: string, readonly date: string, readonly patient: { readonly __typename?: 'PatientRegisterDetails', readonly _id?: string | null, readonly patientUuid?: string | null, readonly name?: string | null, readonly dateOfBirth?: string | null, readonly gender?: Types.Gender | null, readonly address?: { readonly __typename?: 'Address', readonly street?: string | null, readonly ward?: string | null, readonly subCounty?: string | null, readonly state?: string | null } | null, readonly phoneNumber?: { readonly __typename?: 'PatientDetailsPhoneNumber', readonly value?: string | null, readonly ownership?: string | null } | null }, readonly careActivities?: ReadonlyArray<{ readonly __typename?: 'DiagnosisReceived', readonly _id: string, readonly type: string, readonly careActivity?: { readonly __typename: 'DiagnosisReceivedDetails', readonly name?: string | null } | null } | { readonly __typename?: 'InvestigationPerformed', readonly _id: string, readonly type: string, readonly careActivity?: { readonly __typename: 'InvestigationPerformedDetails', readonly investigationId?: string | null, readonly name?: string | null } | null } | { readonly __typename?: 'InvestigationRequested', readonly _id: string, readonly type: string, readonly careActivity?: { readonly __typename: 'InvestigationRequestedDetails', readonly investigationId?: string | null, readonly name?: string | null } | null } | { readonly __typename?: 'PrescriptionDispensed', readonly _id: string, readonly type: string, readonly careActivity?: { readonly __typename: 'PrescriptionDispensedDetails' } | null } | { readonly __typename?: 'PrescriptionIssued', readonly _id: string, readonly type: string, readonly careActivity?: { readonly __typename: 'PrescriptionIssuedDetails', readonly id?: string | null, readonly medication?: { readonly __typename?: 'PatientRegisterMedication', readonly name?: string | null } | null } | null } | null> | null } | null> | null } | null };


export const RegisterRecordsDocument = gql`
    query RegisterRecords($input: RegisterRecordsInput!) {
  registerRecords(input: $input) {
    total
    limit
    offset
    records {
      _id
      date
      patient {
        _id
        patientUuid
        name
        dateOfBirth
        gender
        address {
          street
          ward
          subCounty
          state
        }
        phoneNumber {
          value
          ownership
        }
      }
      careActivities {
        _id
        type
        careActivity {
          __typename
          ... on DiagnosisReceivedDetails {
            name
          }
          ... on InvestigationRequestedDetails {
            investigationId
            name
          }
          ... on InvestigationPerformedDetails {
            investigationId
            name
          }
          ... on PrescriptionIssuedDetails {
            id
            medication {
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRegisterRecordsQuery__
 *
 * To run a query within a React component, call `useRegisterRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterRecordsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterRecordsQuery(baseOptions: Apollo.QueryHookOptions<RegisterRecordsQuery, RegisterRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegisterRecordsQuery, RegisterRecordsQueryVariables>(RegisterRecordsDocument, options);
      }
export function useRegisterRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisterRecordsQuery, RegisterRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegisterRecordsQuery, RegisterRecordsQueryVariables>(RegisterRecordsDocument, options);
        }
export type RegisterRecordsQueryHookResult = ReturnType<typeof useRegisterRecordsQuery>;
export type RegisterRecordsLazyQueryHookResult = ReturnType<typeof useRegisterRecordsLazyQuery>;
export type RegisterRecordsQueryResult = Apollo.QueryResult<RegisterRecordsQuery, RegisterRecordsQueryVariables>;